import cn from 'classnames';

import s from './Check.module.scss';

const Check = ({ className = '' }: { className?: string }) => {
  return (
    <svg
      className={cn(s.root, className)}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
    >
      <path
        d="M0 6.00002L5 11L14 2.00002L12.59 0.580017L5 8.17002L1.41 4.59002L0 6.00002Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { Check };
